import React from "react";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Title } from "./components/Title";
import { Cta } from "./components/Cta";

export const AboutPage = () => {
    return (
        <>
        <Header />
        <Title title="O Nama" />
        <main>

           {/* <!-- Tpm Education Experience Area Start --> */}
            <section className="education-experience tmp-section-gapBottom">
                <div className="container">
                    
                     <div className="experiences-wrapper v2">
                        <div className="row g-5">
                            <div className="col-lg-6">
                                <div className="experiences-wrap-right-content">
                                    <img className="tmp-scroll-trigger tmp-zoom-in animation-order-1" fetchPriority="high" src="assets/images/onama.webp" alt="o nama slika" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="experiences-wrap-left-content">

                                    <h2 className="custom-title mb-32 tmp-scroll-trigger tmp-fade-in animation-order-1">Fokusirani na vrednost <span><img
                                    src="assets/images/custom-line/custom-line.png" alt="custom-line" /></span></h2>
                                    <div className="experience-content tmp-scroll-trigger tmp-fade-in animation-order-1">
                                        {/* <p className="ex-subtitle">experience</p> */}
                                        <h2 className="ex-name">Naša Misija</h2>
                                        {/* <h3 className="ex-title">UI/UX Designer</h3> */}
                                        <p className="ex-para">Da kreiramo digitalne proizvode koji kombinuju funkcionalnost, estetiku i merljiv rast poslovanja.</p>
                                    </div>

                                    <div className="experience-content tmp-scroll-trigger tmp-fade-in animation-order-2">
                                        {/* <p className="ex-subtitle">experience</p> */}
                                        <h2 className="ex-name">Naše Vrednosti</h2>
                                        {/* <h3 className="ex-title">UI/UX Designer</h3> */}
                                        <p className="ex-para">Transparentnost u komunikaciji - Kontinuirano učenje i inovacije - Partnerski odnos sa klijentima</p>
                                    </div>

                                    <div className="experience-content tmp-scroll-trigger tmp-fade-in animation-order-3">
                                        {/* <p className="ex-subtitle">experience</p> */}
                                        <h2 className="ex-name">Iskustvo</h2>
                                        {/* <h3 className="ex-title">UI/UX Designer</h3> */}
                                        <p className="ex-para">Više od 120 lansiranih sajtova za kompanije u regionu i inostranstvu.</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-12">
                                <p>Više od decenije kreiramo web sajtove koji donose rezultate. Naš tim spaja strateški marketing i modernu tehnologiju kako bismo vam pružili jasnu sliku o ceni i benefitima svake faze.</p>
                                {/* <p>Radimo agilno i transparentno: svaka faza ima merenja, a vi imate uvid u tok rada i budžet. Zato klijenti koji traže pouzdan tim za "izrada web sajta cena" biraju nas.</p> */}
                            </div>
                        </div>
                    </div>

                    <div className="row mt-5 mb-5">
                        <div className="col">
                            <h2 className="custom-title mb-32 tmp-scroll-trigger tmp-fade-in animation-order-1">Šta nas izdvaja <span><img src="assets/images/custom-line/custom-line.png"
                                alt="custom-line" /></span>
                            </h2>
                            <p>Ne nudimo generičke pakete. Svaki projekat prolazi kroz detaljnu analizu i planiranje u skladu sa ciljevima vašeg brenda.</p>
                            <p className="itu--noted">14+ godina iskustva</p>
                        </div>
                    </div>
                    <div className="row g-5">

                        <div className="col-lg-6 col-sm-6">
                            <div className="education-experience-card tmponhover tmp-scroll-trigger tmp-fade-in animation-order-1">
                                {/* <h4 className="edu-sub-title">Trainer Marketing</h4> */}
                                <h2 className="edu-title">Transparentan proces</h2>
                                <p className="edu-para">Od prvog brifa do lansiranja dobijate jasne korake, rokove i troškove. Verujemo da "izrada web sajta cena" mora biti tema o kojoj otvoreno razgovaramo.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6">
                            <div className="education-experience-card tmponhover tmp-scroll-trigger tmp-fade-in animation-order-2">
                                {/* <h4 className="edu-sub-title">Assistant Director</h4> */}
                                <h2 className="edu-title">Timski pristup</h2>
                                <p className="edu-para">Na projektu rade dizajner, SEO stručnjak i developer kako bismo spojili estetiku, performanse i rast poseta.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6">
                            <div className="education-experience-card tmponhover tmp-scroll-trigger tmp-fade-in animation-order-3">
                                {/* <h4 className="edu-sub-title">Design Assistant</h4> */}
                                <h2 className="edu-title">Posvećenost rezultatima</h2>
                                <p className="edu-para">Pratimo KPI-jeve, analitiku i konverzije kako bismo optimizovali svaki element sajta i povećali vaš ROI.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6">
                            <div className="education-experience-card tmponhover tmp-scroll-trigger tmp-fade-in animation-order-4">
                                {/* <h4 className="edu-sub-title">Design Assistant</h4> */}
                                <h2 className="edu-title">Transparentni pristup</h2>
                                <p className="edu-para">Radimo agilno i transparentno: svaka faza ima merenja, a vi imate uvid u tok rada i budžet. Zato klijenti koji traže pouzdan tim za "izrada web sajta cena" biraju nas.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6">
                            <div className="education-experience-card tmponhover tmp-scroll-trigger tmp-fade-in animation-order-4">
                                {/* <h4 className="edu-sub-title">Design Assistant</h4> */}
                                <h2 className="edu-title">Partnerstvo, ne samo projekat</h2>
                                <p className="edu-para">Uspostavljamo dugoročnu saradnju i pomažemo vam da razvijate sajt u skladu sa promenama na tržištu.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6">
                            <div className="education-experience-card tmponhover tmp-scroll-trigger tmp-fade-in animation-order-4">
                                {/* <h4 className="edu-sub-title">Design Assistant</h4> */}
                                <h2 className="edu-title">SEO kao sastavni deo</h2>
                                <p className="edu-para">Od wireframe faze planiramo SEO arhitekturu sadržaja tako da fraze poput "izrada web sajta cena" brzo donesu rezultate.</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <p>Kao i kolege <a target="_blank" rel="noopener noreferrer" href="https://www.it-usluge.net/izrada-sajta.html">izrade sajtova IT Usluge</a>, radimo i kompleksne projekte SAAS aplikacije i AI integracije.</p>
                            </div>
                        </div>

                    </div>

                   
                </div>
            </section>
            {/* <!-- Tpm Education Experience Area End --> */}

            <Cta klasa="itu-padding-top-none" />

        </main>
        
        <Footer />
        </>
    );
}